'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import ResultHeader from './ResultHeader';
import ResultInfo from './ResultInfo';
import ResultSection from './ResultSection';
import GradeTypeConstants from '../../constants/GradeTypeConstants';
import Tag from './Tag';

var YesNoResultSection = /*#__PURE__*/function (_React$Component) {
  _inherits(YesNoResultSection, _React$Component);

  function YesNoResultSection() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, YesNoResultSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(YesNoResultSection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getTickOrXIconClasses = function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      return classNames("icon", props.gradeType === GradeTypeConstants.GOOD && 'icon-check-circle', props.gradeType === GradeTypeConstants.BAD && 'icon-delete-circle');
    };

    return _this;
  }

  _createClass(YesNoResultSection, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/_jsxs(ResultSection, {
        gradeType: props.gradeType,
        children: [/*#__PURE__*/_jsx(Tag, Object.assign({}, props)), /*#__PURE__*/_jsx(ResultHeader, Object.assign({}, props)), /*#__PURE__*/_jsx("div", {
          className: this.getTickOrXIconClasses()
        }), /*#__PURE__*/_jsx(ResultInfo, Object.assign({}, props))]
      });
    }
  }]);

  return YesNoResultSection;
}(React.Component);

YesNoResultSection.propTypes = {
  gradeType: PropTypes.string
};
export { YesNoResultSection as default };